import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  eventViewerHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: '10px'
  },
  eventViewerTitle: {
    fontSize: '1.5rem',
    fontWeight: 700,
    letterSpacing: '0.5px',
    margin: 0,
  },
  metaPills: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
  },
  metaPill: {
    background: '#335977',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '20px',
    padding: '4px 14px',
    fontSize: '0.76rem',
    color: 'rgba(255, 255, 255, 0.85)',
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
  },
  metaPillStrong: {
    color: '#fff',
    fontWeight: 'bold',
  },
  urlBar: {
    background: '#16213e',
    padding: '16px 32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    borderBottom: '1px solid #0f3460',
  },
  urlExtraGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    width: '100%'
  },
  reqTextarea: {
    background: '#0f1f38',
    border: '1px solid #2d4a6e',
    borderRadius: '8px',
    height: '80px',
    overflow: 'auto',
  },
  urlUpload: {
    borderTop: '1px solid #1e3a5f',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  urlUploadRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
    paddingTop: '10px',
  },
  fileInput: {
    display: 'none',
  },
  fileLabel: {
    padding: '8px 14px',
    background: '#0f1f38',
    border: '1px solid #2d4a6e',
    borderRadius: '8px',
    color: '#94a3b8',
    fontSize: '0.82rem',
    fontFamily: '"SF Mono", "Fira Code", monospace',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    '&:hover': {
      borderColor: '#2563eb',
      color: '#e2e8f0',
    },
  },
  fileName: {
    color: '#64748b',
    fontSize: '0.78rem',
    fontFamily: '"SF Mono", "Fira Code", monospace',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '220px',
  },
  fileNameChosen: {
    color: '#93c5fd',
  },
  uploadBtn: {
    padding: '5px 20px',
    background: 'linear-gradient(135deg, #065f46, #059669)',
    color: '#fff',
    borderRadius: '8px',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    '&:hover': {
      opacity: 0.9,
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
  urlBarLabel: {
    color: '#94a3b8',
    fontWeight: 600,
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: '10px'
  },
  urlBarLabelRow: {
    color: '#94a3b8',
    fontWeight: 600,
    textTransform: 'uppercase',
    fontSize: '0.78rem',
    letterSpacing: '0.5px',
    whiteSpace: 'nowrap',
    display: 'inline-block',
  },
  labelSubtext: {
    opacity: 0.55,
    fontSize: '0.7rem',
    fontWeight: 400,
  },
  submitBtn: {
    padding: '5px 22px',
    background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
    color: '#fff',
    borderRadius: '8px',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      opacity: 0.9,
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
  statusMsg: {
    fontSize: '0.8rem',
    padding: '6px 14px',
    borderRadius: '6px',
    display: 'none',
    alignItems: 'center',
    gap: '6px',
    whiteSpace: 'nowrap',
  },
  statusMsgLoading: {
    display: 'flex',
    background: 'rgba(37, 99, 235, 0.18)',
    color: '#93c5fd',
    border: '1px solid rgba(37, 99, 235, 0.3)',
  },
  statusMsgError: {
    display: 'flex',
    background: 'rgba(220, 38, 38, 0.18)',
    color: '#fca5a5',
    border: '1px solid rgba(220, 38, 38, 0.3)',
  },
  statusMsgSuccess: {
    display: 'flex',
    background: 'rgba(5, 150, 105, 0.18)',
    color: '#6ee7b7',
    border: '1px solid rgba(5, 150, 105, 0.3)',
  },
  spinner: {
    width: '14px',
    height: '14px',
    border: '2px solid rgba(255, 255, 255, 0.2)',
    borderTopColor: '#93c5fd',
    borderRadius: '50%',
    animation: '$spin 0.7s linear infinite',
    flexShrink: 0,
  },
  '@keyframes spin': {
    to: {
      transform: 'rotate(360deg)',
    },
  },

  container: {
    padding: '28px 32px',
  },
  sectionTitle: {
    fontSize: '12px',
    fontWeight: 1000,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    color: '#6b7280',
    marginBottom: '12px',
    paddingTop: '10px',
    marginRight: '10px',
  },
  card: {
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.06)',
    overflow: 'hidden',
    marginBottom: '20px',
  },
  filterBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap',
    padding: '14px 0 16px 0',
  },
  filterInput: {
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    color: '#374151',
    width: '400px',
    paddingLeft: '20px'
  },
  filterSelect: {
    padding: '0px 12px',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    background: '#fff',
    cursor: 'pointer',
    '&:focus': {
      borderColor: '#2563eb',
    },
  },
  selectPaper: {
    maxHeight: '300px',
    marginTop: '4px',
  },
  resultCount: {
    fontSize: '0.78rem',
    color: '#6b7280',
    fontWeight: 600,
    marginLeft: 'auto'
  },
  clearBtn: {
    padding: '5px 13px',
    background: '#f3f4f6',
    color: '#374151',
    border: '1px solid #e5e7eb',
    borderRadius: '7px',
    fontSize: '0.78rem',
    fontWeight: 600,
    cursor: 'pointer',
    '&:hover': {
      background: '#e5e7eb',
    },
  },
  exportBtn: {
    background: 'linear-gradient(135deg, #065f46, #059669)',
    borderRadius: '7px',
    fontSize: '0.78rem',
    fontWeight: 700,
    color: '#fff',
    '&:hover': {
      opacity: 0.88,
    },
  },


  tableWrap: {
    overflowX: 'auto',
  },
  eventsTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '0.84rem',
    '& thead th': {
      background: '#335977',
      padding: '11px 14px',
      textAlign: 'left',
      fontSize: '0.72rem',
      fontWeight: 700,
      letterSpacing: '0.6px',
      textTransform: 'uppercase',
      color: '#FFE784',
      borderBottom: '2px solid #e5e7eb',
      whiteSpace: 'nowrap',
    },
    '& tbody tr': {
      transition: 'background 0.15s',
      '&:hover': {
        background: '#f8fafc',
      },
    },
    '& tbody td': {
      padding: '12px 14px',
      borderBottom: '1px solid #f0f2f5',
      color: '#374151',
    },
    '& tbody tr:last-child td': {
      borderBottom: 'none',
    },
  },
  // Badges
  badge: {
    display: 'inline-block',
    padding: '3px 10px',
    borderRadius: '20px',
    fontSize: '0.72rem',
    fontWeight: 700,
    letterSpacing: '0.4px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  badgeGreen: {
    background: '#d1fae5',
    color: '#065f46',
  },
  badgeBlue: {
    background: '#dbeafe',
    color: '#1e40af',
  },
  badgeYellow: {
    background: '#fef3c7',
    color: '#92400e',
  },
  badgeRed: {
    background: '#fee2e2',
    color: '#991b1b',
  },
  badgeOrange: {
    background: '#ffedd5',
    color: '#c2410c',
  },
  badgePurple: {
    background: '#ede9fe',
    color: '#5b21b6',
  },
  badgeGray: {
    background: '#f3f4f6',
    color: '#374151',
  },
  badgeTeal: {
    background: '#e0f2fe',
    color: '#0369a1',
  },
  sortableHeader: {
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
      background: '#eef2ff !important',
      color: '#2563eb',
    },
  },
  sortedHeader: {
    background: '#eef2ff !important',
    color: '#1d4ed8 !important',
  },
  sortIcon: {
    color: '#b0bac6',
    fontSize: '0.62rem',
    marginLeft: '3px',
  },
  sortIconActive: {
    color: '#1d4ed8',
  },
  tableHeader: {
    fontWeight: 700,
    backgroundColor: '#335977',
  },
  isBold: {
    fontWeight: 700,
    color: '#FFFFFF',
  },
  sortContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '4px',
    cursor: 'pointer',
  },
  sortUp: {
    marginBottom: '-8px',
  },
  sortDown: {
    marginTop: '-4px',
  },
  active: {
    color: '#F37320',
  },
  inactive: {
    color: '#b0bac6',
  },
  emptyTableContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '150px',
    flexDirection: 'column',
  },
  noEvents: {
    textAlign: 'center',
    padding: '20px',
    color: '#9ca3af'
  },
  titleWrapper: {
    whiteSpace: 'nowrap',
    fontSize: '0.8rem'
  },
  logBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    padding: '5px 12px',
    background: '#f5f3ff',
    color: '#7c3aed',
    border: '1px solid #ddd6fe',
    borderRadius: '6px',
    fontSize: '0.78rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background 0.15s, border-color 0.15s',
    whiteSpace: 'nowrap',
    '&:hover': {
      background: '#ede9fe',
      borderColor: '#c4b5fd',
    },
  },
  logBtnOpen: {
    '& $arrow': {
      transform: 'rotate(180deg)',
    },
  },
  intervalBtn: {
    padding: '5px 12px',
    background: '#eff6ff',
    color: '#2563eb',
    border: '1px solid #bfdbfe',
    borderRadius: '6px',
    fontSize: '0.78rem',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  intervalBtnOpen: {
    '& $arrow': {
      transform: 'rotate(180deg)',
    },
  },
  arrow: {
    transition: 'transform 0.2s',
    display: 'inline-block',
    marginLeft: '5px'
  },
  expandRow: {
    '& td': {
      padding: 0,
      borderBottom: '1px solid #e5e7eb',
      background: '#fafbff',
    },
  },
  expandInner: {
    padding: '20px 24px',
    animation: '$fadeIn 0.2s ease',
  },
  expandInnerHidden: {
    display: 'none',
  },
  '@keyframes fadeIn': {
    from: { opacity: 0, transform: 'translateY(-4px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
  timeline: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    position: 'relative',
    paddingLeft: '24px',
  },
  tlItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      left: '-12px',
      top: '9px',
      width: '2px',
      height: 'calc(100% + 10px)',
      background: 'linear-gradient(180deg, #e0e7ff, #f3f4f6)',
      zIndex: 0,
    },
    '&:last-child::after': {
      display: 'none',
    },
  },
  tlDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    flexShrink: 0,
    marginLeft: '-18px',
    marginTop: '2px',
    position: 'relative',
    zIndex: 1,
    border: '3px solid #FFFFFF',
  },
  tlTime: {
    fontSize: '0.75rem',
    fontFamily: '"SF Mono", monospace',
    color: '#6b7280',
    whiteSpace: 'nowrap',
    minWidth: '150px',
    paddingTop: '1px',
  },
  tlText: {
    fontSize: '0.82rem',
    color: '#374151',
    lineHeight: 1.4,
  },
  kvGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
    gap: '10px',
  },
  kvGridSpaced: {
    marginTop: '10px',
  },
  kvItem: {
    background: '#f9fafb',
    border: '1px solid #e5e7eb',
    borderRadius: '6px',
    padding: '8px 12px',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  },
  kvLabel: {
    fontSize: '0.7rem',
    fontWeight: 600,
    color: '#6b7280',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '3px',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  },
  kvValue: {
    fontSize: '0.82rem',
    color: '#1f2937',
    fontFamily: '"SF Mono", "Fira Code", monospace',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
  },
  eventDetailsSection: {
    marginTop: '20px',
  },
  drillBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    padding: '5px 12px',
    background: '#eff6ff',
    color: '#2563eb',
    border: '1px solid #bfdbfe',
    borderRadius: '6px',
    fontSize: '0.78rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background 0.15s, border-color 0.15s',
    whiteSpace: 'nowrap',
    '&:hover': {
      background: '#dbeafe',
      borderColor: '#93c5fd',
    },
  },
  drillBtnOpen: {
    '& $arrow': {
      transform: 'rotate(180deg)',
    },
  },
  intervalTableWrap: {
    display: 'inline-block',
    width: 'auto',
    maxWidth: '100%',
    overflowX: 'auto',
    backgroundColor: '#fff',
    margin: '-15px'
  },
  intervalTableCompact: {
    width: 'auto',
    tableLayout: 'auto',
    borderCollapse: 'collapse',
    '& thead th': {
      fontSize: '0.65rem',
      padding: '5px 8px',
      whiteSpace: 'nowrap',
    },
    '& tbody td': {
      fontSize: '0.75rem',
      padding: '4px 8px',
      whiteSpace: 'nowrap',
    },
    '& th:nth-child(n+3), & td:nth-child(n+3)': {
      textAlign: 'right',
    },
    '& tbody tr:nth-child(even)': {
      background: '#f0f4ff',
    },
  },
  intervalTable: {
    width: '10%',
    borderCollapse: 'collapse',
    '& thead th': {
      background: '#eff6ff',
      color: '#1e40af',
      fontSize: '0.65rem',
      padding: '5px 8px',
      whiteSpace: 'nowrap',
    },
    '& tbody td': {
      fontSize: '0.75rem',
      padding: '4px 8px',
      whiteSpace: 'nowrap',
    },
    '& th:nth-child(n+3), & td:nth-child(n+3)': {
      textAlign: 'right',
    },
    '& tbody tr:nth-child(even)': {
      background: '#f0f4ff',
    },
  },
  chip: {
    display: 'inline-block',
    fontFamily: '"SF Mono", "Fira Code", monospace',
    fontSize: '0.78rem',
    background: '#f1f5f9',
    borderRadius: '4px',
    padding: '2px 6px',
    color: '#334155',
  },
  chipGreen: {
    background: '#d1fae5',
    color: '#065f46',
  },
  chipBlue: {
    background: '#dbeafe',
    color: '#1e40af',
  },
  chipOrange: {
    background: '#ffedd5',
    color: '#c2410c',
  },
  summaryRow: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
    marginBottom: '12px',
  },
  statChip: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: '#fff',
    borderRadius: '10px',
    padding: '10px 18px',
    minWidth: '110px',
  },
  statChipBlue: {
    background: 'linear-gradient(135deg, #1e40af, #2563eb)',
  },
  statChipGreen: {
    background: 'linear-gradient(135deg, #065f46, #059669)',
  },
  statChipOrange: {
    background: 'linear-gradient(135deg, #c2410c, #ea580c)',
  },
  statChipPurple: {
    background: 'linear-gradient(135deg, #5b21b6, #7c3aed)',
  },
  statChipVal: {
    fontSize: '1.3rem',
    fontWeight: 700,
  },
  statChipLbl: {
    fontSize: '0.68rem',
    opacity: 0.8,
    letterSpacing: '0.4px',
    textTransform: 'uppercase',
  },
  chartWrap: {
    marginBottom: '16px',
    padding: '16px',
    background: '#f9fafb',
    borderRadius: '8px',
    border: '1px solid #e5e7eb',
  },
  chartTitle: {
    fontSize: '0.82rem',
    fontWeight: 600,
    color: '#374151',
    marginBottom: '12px',
    textAlign: 'center',
  },
  noIntervalData: {
    color: '#9ca3af',
    fontSize: '0.82rem',
    padding: '12px 0',
  },
  intervalHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '14px',
  },
  intervalHeaderTitle: {
    margin: 0,
  },
  exportIntervalBtn: {
    fontSize: '0.75rem',
    padding: '5px 11px',
  },
  chartContainer: {
    background: '#fff',
    borderRadius: '8px',
    padding: '10px 14px 8px',
    marginBottom: '14px',
    position: 'relative',
    maxWidth: '700px',
  },
  chartTitles: {
    fontSize: '.68rem',
    fontWeight: 700,
    letterSpacing: '.6px',
    textTransform: 'uppercase',
    color: '#6b7280',
    marginBottom: '6px',
  },
  hintWrapper: {
    background: '#1e293b',
    color: '#fff',
    padding: '8px 12px',
    borderRadius: '5px',
    fontSize: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
    minWidth: '180px',
  },
  legendContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '16px',
    marginBottom: '8px',
    fontSize: '10px',
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  hintTime: {
    fontWeight: 600,
    marginBottom: '4px',
  },
  hintSocData: {
    color: '#c4b5fd',
  },
  hintDischargeData: {
    color: '#fdba74',
  },
  intervalsHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '12px',
  },
  // Active Sites Styles
  activeSitesStatsBar: {
    display: 'flex',
    gap: '12px',
    marginBottom: '16px',
    justifyContent: 'space-between',
    width: '100%'
  },
  activeSitesStatChip: {
    background: 'linear-gradient(135deg, #1e3a8a, #2563eb)',
    color: '#fff',
    borderRadius: '10px',
    padding: '12px 18px',
    width: '22%',
    textAlign: 'center'
  },
  activeSitesStatVal: {
    fontSize: '1.5rem',
    fontWeight: 700,
    marginBottom: '4px',
  },
  activeSitesStatLbl: {
    fontSize: '0.7rem',
    opacity: 0.85,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    marginBottom: '2px',
  },
  activeSitesStatSub: {
    fontSize: '0.7rem',
    opacity: 0.7,
  },
  activeSitesStatSubPositive: {
    fontSize: '0.7rem',
    opacity: 0.7,
    color: '#6ee7b7',
  },
  activeSitesStatSubNegative: {
    fontSize: '0.7rem',
    opacity: 0.7,
    color: '#fca5a5',
  },
  activeSitesStatSubNeutral: {
    fontSize: '0.7rem',
    opacity: 0.7,
    color: 'rgba(255,255,255,.6)',
  },
  activeSitesStatValLarge: {
    fontSize: '1.05rem',
    fontWeight: 700,
    marginTop: '4px',
    marginBottom: '4px',
  },
  activeSitesFilterContainer: {
    marginLeft: 'auto',
    display: 'flex',
    gap: '10px',
  },
  activeSitesTableCellRight: {
    textAlign: 'right',
  },
  activeSitesTableCellCenter: {
    textAlign: 'center',
  },
  trendPositive: {
    color: '#16a34a',
    fontWeight: 600,
  },
  trendNegative: {
    color: '#dc2626',
    fontWeight: 600,
  },
  activeSitesGroupSpan: {
    color: '#6b7280',
    fontWeight: 400,
  },
  activeSitesGroupCell: {
    color: '#6b7280',
    fontSize: '0.78rem',
  },
  activeSitesTotalsRow: {
    background: '#f9fafb',
    borderTop: '2px solid #e5e7eb',
    fontWeight: 600,
    color: '#6b7280',
  },
  activeSitesZeroValue: {
    color: '#e5e7eb',
  },
  activeSitesIndexCell: {
    width: '36px',
  },
  activeSitesTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '0.82rem',
    '& thead th': {
      background: '#335977',
      padding: '10px 12px',
      textAlign: 'left',
      fontSize: '0.7rem',
      fontWeight: 700,
      letterSpacing: '0.6px',
      textTransform: 'uppercase',
      color: '#FFE784',
      borderBottom: '2px solid #e5e7eb',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      '&:hover': {
        background: '#3d6a89',
      },
    },
    '& tbody tr': {
      transition: 'background 0.15s',
      '&:hover': {
        background: '#f8fafc',
      },
    },
    '& tbody td': {
      padding: '10px 12px',
      borderBottom: '1px solid #f0f2f5',
      whiteSpace: 'nowrap',
    },
    '& tfoot td': {
      padding: '10px 12px',
      borderTop: '2px solid #e5e7eb',
      fontWeight: 600,
      background: '#f9fafb',
    },
  },
  activeSitesNum: {
    textAlign: 'right',
  },
  activeSitesSorted: {
    background: '#3d6a89 !important',
  },
  activeSitesSortIcon: {
    marginLeft: '4px',
    fontSize: '0.9rem',
  },
  activeSitesGroupRow: {
    background: '#eff6ff !important',
    '& td': {
      fontWeight: 700,
      color: '#1d4ed8',
      fontSize: '0.78rem',
      padding: '8px 14px',
    },
  },
  activeSitesCellZero: {
    color: '#d1d5db',
  },
  activeSitesCellLow: {
    color: '#9ca3af',
  },
  activeSitesCellMid: {
    color: '#374151',
  },
  activeSitesCellHigh: {
    color: '#1d4ed8',
    fontWeight: 600,
  },
  activeSitesCellPeak: {
    color: '#7c3aed',
    fontWeight: 700,
  },
  activeSitesToggleBtn: {
    padding: '7px 14px',
    background: '#f3f4f6',
    color: '#374151',
    border: '1px solid #e5e7eb',
    borderRadius: '7px',
    fontSize: '0.78rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.15s',
    '&:hover': {
      background: '#e5e7eb',
    },
  },
  activeSitesToggleBtnActive: {
    background: '#dbeafe',
    borderColor: '#93c5fd',
    color: '#1e40af',
  },
  activeSitesViewToggleGroup: {
    display: 'flex',
    borderRadius: '8px',
    overflow: 'hidden',
    border: '1px solid #e5e7eb',
    flexShrink: 0,
  },
  activeSitesViewToggleBtn: {
    padding: '7px 18px',
    background: '#f3f4f6',
    color: '#374151',
    border: 'none',
    fontSize: '0.82rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background 0.15s, color 0.15s',
    '&:hover': {
      background: '#e5e7eb',
    },
  },
  activeSitesViewToggleBtnActive: {
    background: '#2563eb',
    color: '#fff',
    '&:hover': {
      background: '#2563eb',
    },
  },
  activeSitesViewToggleBtnBorder: {
    borderLeft: '1px solid #e5e7eb',
  },
  activeSitesEmptyState: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#9ca3af',
    '& .icon': {
      fontSize: '3rem',
      marginBottom: '12px',
    },
    '& h3': {
      fontSize: '1.1rem',
      color: '#6b7280',
      marginBottom: '6px',
    },
    '& p': {
      fontSize: '0.85rem',
    },
  },
  activeSitesProgramName: {
    fontWeight: 600,
  },
  activeSitesProgramKey: {
    fontSize: '0.75rem',
    color: '#9ca3af',
    marginTop: '2px',
  },
  activeSitesReqBodyInput: {
    color: '#e2e8f0',
    padding: '8px 12px',
  },
  // Drill-down chip
  drillDownCellWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
  },
  drillDownChip: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '22px',
    height: '20px',
    borderRadius: '4px',
    background: '#dbeafe',
    color: '#3b82f6',
    cursor: 'pointer',
    flexShrink: 0,
    transition: 'background 0.15s',
    '&:hover': {
      background: '#bfdbfe',
    },
  },
  drillDownChipPlaceholder: {
    display: 'inline-block',
    width: '22px',
    height: '20px',
    flexShrink: 0,
  },
  drillDownChipIcon: {
    fontSize: '0.9rem',
  },
  drillDownMaxMonthlyLabel: {
    display: 'inline-block',
    marginLeft: '6px',
    padding: '1px 6px',
    borderRadius: '4px',
    background: '#dbeafe',
    color: '#1e40af',
    fontSize: '0.65rem',
    fontWeight: 600,
    verticalAlign: 'middle',
  },
  // Drill-down inline expanded row
  drillDownExpandCell: {
    padding: '0 !important',
    background: '#f8fafc',
  },
  drillDownExpandInner: {
    padding: '12px 16px',
  },
  drillDownHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '12px',
    flexWrap: 'wrap',
  },
  drillDownHeaderTitle: {
    fontWeight: 700,
    fontSize: '0.8rem',
    color: '#374151',
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
  },
  drillDownChangeCountBar: {
    display: 'flex',
    gap: '12px',
  },
  drillDownChangeAdded: {
    color: '#16a34a',
    fontWeight: 600,
    fontSize: '0.8rem',
  },
  drillDownChangeDeleted: {
    color: '#dc2626',
    fontWeight: 600,
    fontSize: '0.8rem',
  },
  drillDownLoadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '20px',
  },
  drillDownTablesContainer: {
    display: 'flex',
    gap: '24px',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  drillDownTableSection: {
    flex: '0 1 280px',
    minWidth: '200px',
    maxWidth: '320px',
  },
  drillDownSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '6px',
  },
  drillDownSectionTitle: {
    fontWeight: 700,
    fontSize: '0.8rem',
    color: '#1f2937',
    textTransform: 'uppercase',
  },
  drillDownExportBtn: {
    fontSize: '0.72rem',
    color: '#2563eb',
    textTransform: 'none',
    fontWeight: 600,
    padding: '2px 8px',
    minWidth: 'auto',
    '&:hover': {
      background: '#eff6ff',
    },
  },
  drillDownNestedTableWrap: {
    maxHeight: '260px',
    overflowY: 'auto',
    border: '1px solid #e5e7eb',
    borderRadius: '6px',
  },
  drillDownNestedTable: {
    '& thead': {
      position: 'sticky',
      top: 0,
      zIndex: 1,
    },
  },
  drillDownNestedTh: {
    background: '#335977',
    color: '#FFE784',
    fontWeight: 700,
    fontSize: '0.72rem',
    textTransform: 'uppercase',
    padding: '4px 8px',
    '&:first-child': {
      width: '40px',
      textAlign: 'right',
    },
  },
  drillDownNestedTd: {
    fontSize: '0.78rem',
    padding: '3px 8px',
    borderBottom: '1px solid #f3f4f6',
    '&:first-child': {
      width: '40px',
      textAlign: 'right',
      color: '#9ca3af',
    },
  },
  drillDownEmpty: {
    textAlign: 'center',
    padding: '20px',
    color: '#9ca3af',
    fontSize: '0.85rem',
  },
  // Pagination
  paginationBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
  },
  paginationLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  paginationLabel: {
    fontSize: '0.82rem',
    color: '#6b7280',
  },
  paginationSelect: {
    fontSize: '0.82rem',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    padding: '2px 4px',
    '& .MuiSelect-select': {
      padding: '2px 24px 2px 8px',
    },
  },
  paginationInfo: {
    fontSize: '0.82rem',
    color: '#6b7280',
    marginLeft: '8px',
  },
  paginationRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
  },
  paginationArrow: {
    minWidth: '32px',
    width: '32px',
    height: '32px',
    padding: 0,
    fontSize: '1.2rem',
    color: '#374151',
    borderRadius: '4px',
    '&:hover': {
      background: '#f3f4f6',
    },
    '&:disabled': {
      color: '#d1d5db',
    },
  },
  paginationPageBtn: {
    minWidth: '32px',
    width: '32px',
    height: '32px',
    padding: 0,
    fontSize: '0.82rem',
    color: '#374151',
    borderRadius: '4px',
    fontWeight: 500,
    '&:hover': {
      background: '#f3f4f6',
    },
  },
  paginationPageBtnActive: {
    background: '#2563eb',
    color: '#fff',
    fontWeight: 700,
    '&:hover': {
      background: '#1d4ed8',
    },
  },
  paginationEllipsis: {
    width: '32px',
    textAlign: 'center',
    fontSize: '0.82rem',
    color: '#9ca3af',
  },
}))

export { useStyles }